module.exports = __webpack_public_path__ + "img/upload.db153fa2.svg";